import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var typographies = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle', 'body1', 'body', 'button', 'caption', 'captionMedium', 'badges', 'overline'];
export default (function (theme) {
  return _objectSpread(_objectSpread({
    root: {
      display: 'inherit',
      color: theme.colors.neutral900
    }
  }, typographies.reduce(function (obj, key) {
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, _objectSpread({}, theme.typography[key])));
  }, {})), {}, {
    truncated: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    bold: {
      fontWeight: 500
    },
    divider: {
      borderBottom: "1px solid ".concat(theme.colors.neutral400),
      paddingBottom: 8
    },
    highlighted: {
      '-webkit-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      background: 'linear-gradient(90deg, #FF8905 0%, #F54853 80%)',
      color: theme.colors.orange500
    }
  });
});